<template>
  <div>
    <AppHeader />
    <HeroSection />
    <RaceFormat />
    <VideoGallery />
    <PruebasTable />
    <CategoriesGrid />
    <ScheduleSection />
    <RegistrationTiers />
    <ContactSection />
    <AppFooter />
  </div>
</template>

<script setup>
import { onMounted } from 'vue'
import AppHeader from './components/AppHeader.vue'
import HeroSection from './components/HeroSection.vue'
import RaceFormat from './components/RaceFormat.vue'
import VideoGallery from './components/VideoGallery.vue'
import PruebasTable from './components/PruebasTable.vue'
import CategoriesGrid from './components/CategoriesGrid.vue'
import ScheduleSection from './components/ScheduleSection.vue'
import RegistrationTiers from './components/RegistrationTiers.vue'
import ContactSection from './components/ContactSection.vue'
import AppFooter from './components/AppFooter.vue'

onMounted(() => {
  document.title = 'Hybrid Island Race · Menorca'
})
</script>
